module.exports = __webpack_public_path__ + "img/luxy.5580a45.png";